/* eslint-disable import/prefer-default-export */
import { createActions } from 'redux-actions';
import * as types from './analytics.types';

export const { dataLayerPush } = createActions(types.DATA_LAYER_PUSH);
